import { useEffect } from "react";
import useTranslator from "@/shared/translate/translator";
import ReceiptView from "@/refund/views/receipt";

const Receipt: React.FC = () => {
  const { t } = useTranslator("refund.receipt");

  useEffect(() => {
    document.title = t("pageTitle");
  }, [t]);

  return <ReceiptView />;
};
export default Receipt;
